export const IRIS_FETCH_STARTED = 'IRIS_FETCH_STARTED';
export const IRIS_FETCH_SUCCEEDED = 'IRIS_FETCH_SUCCEEDED';
export const IRIS_FETCH_FAILED = 'IRIS_FETCH_FAILED';